// extracted by mini-css-extract-plugin
export default {"container":"PageWrapper_container__XCOJl","wrapper":"PageWrapper_wrapper__yTAbS"};